// topoEditor/overlayListProvider.js — the generic { id, title } list source for the overlay picker (and later a
// tag picker via the SAME shape). Self-contained: fetches action=get_overlays (archive-scoped, CSRF-guarded like
// docResolve) and maps it to [{ id, title }]. The picker UI (createListPanel / the editor picker hook) stays
// data-source-free and reusable — swap this provider for a get_tags one to get a tag picker with no UI change.

const AJAX_URL = "/includes/ajax.php";

// ajax.php is CSRF-guarded — send the token from <meta name="csrf-token"> (same as docResolve / jQuery's $.ajaxSetup).
function csrfHeaders() {
    const m = document.querySelector('meta[name="csrf-token"]');
    const tok = m && m.getAttribute("content");
    return tok ? { Csrftoken: tok } : {};
}

// Pure: get_overlays response → [{ id, title }] (title = name, + year in parens when present). No I/O → unit-testable.
export function overlayItemsFromResponse(json, { fallbackTitle = "Overlay" } = {}) {
    if (!json || !json.data) { return []; }
    return Object.keys(json.data).map((k) => {
        const o = json.data[k] || {};
        const year = o.year ? " (" + o.year + ")" : "";
        return { id: String(o.id), title: (o.name ? o.name : fallbackTitle + " " + o.id) + year };
    });
}

// Self-contained provider: lazily fetches get_overlays once (request-lifetime cache) → [{ id, title }]. Returns []
// on any error (the picker just shows empty) and does NOT cache the failure, so a later open retries. Injected into
// the entity at registration so overlayLink.js stays pure.
export function createOverlayListProvider({ fallbackTitle } = {}) {
    let cache = null;
    return async function getOverlayList() {
        if (cache) { return cache; }
        try {
            const res = await fetch(AJAX_URL, {
                method: "POST",
                credentials: "same-origin",
                headers: { "Content-Type": "application/x-www-form-urlencoded", ...csrfHeaders() },
                body: "action=get_overlays",
            });
            if (res.ok) {
                const json = await res.json();
                cache = overlayItemsFromResponse(json, { fallbackTitle });
                return cache;
            }
        } catch (e) { /* network error → empty list, not cached (retry next open) */ }
        return [];
    };
}
